import React from 'react';
import { cls } from '@arco-design/mobile-utils';

function NativeEllipsis(_ref) {
  var prefixCls = _ref.prefixCls,
      ellipsis = _ref.ellipsis,
      dangerouslyUseInnerHTML = _ref.dangerouslyUseInnerHTML,
      text = _ref.text,
      maxLine = _ref.maxLine,
      _ref$collapseNode = _ref.collapseNode,
      collapseNode = _ref$collapseNode === void 0 ? '' : _ref$collapseNode,
      onCollapseNodeClick = _ref.onCollapseNodeClick;
  return /*#__PURE__*/React.createElement("div", {
    className: cls(prefixCls + "-native", {
      ellipsis: ellipsis
    }),
    style: {
      WebkitLineClamp: maxLine
    }
  }, dangerouslyUseInnerHTML ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger,@typescript-eslint/naming-convention
  React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }) : /*#__PURE__*/React.createElement("span", null, text), !ellipsis && collapseNode && /*#__PURE__*/React.createElement("span", {
    onClick: onCollapseNodeClick,
    className: cls(prefixCls + "-native-collapse")
  }, collapseNode));
}

export default /*#__PURE__*/React.memo(NativeEllipsis);